// extracted by mini-css-extract-plugin
export default {"button":"GenericButton_button__0AHse","light":"GenericButton_light__DAp6I","dark":"GenericButton_dark__iAYZK"};